import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogBody, DialogFooter, DialogHeader, Input, Typography } from "@material-tailwind/react";
import usePagination from "../../../hooks/usePagination";
import AppTitleContext from "../../../context/AppTitleContext";
import periodsService from "../../../services/periods.service";
import http from "../../../services/httpRequest";
import { AlertTypes } from "../../../models/Enums";
import { HttpStatusCode } from "axios";
import { Period } from "../../../models/Periods";
import './Periods.css'

const Periods = () => {
    const [periods, setPeriods] = useState<Period[]>([]);
    const [isOpenCreateModal, setIsOpenCreateModal] = useState(false);
    const [newPeriodSuggestion, setNewPeriodSuggestion] = useState<any>();
    const [newPeriodId, setNewPeriodId] = useState<any>();
    const [newPeriodEventDate, setNewPeriodEventDate] = useState<any>();
    const { currentData, getPagination } = usePagination<Period[]>(periods, 7);
    const { updateAppTitle } = useContext(AppTitleContext);

    const getPeriods = async () => {
        const resp = await periodsService.getPeriods();
        setPeriods(resp?.reverse() || []);
    }

    const getNewPeriodSuggestion = async () => {
        const resp = await periodsService.getPeriodSuggestion();
        setNewPeriodSuggestion(resp);
    }

    const periodCreator = {
        createPeriod: async () => {
            periodCreator.handleOpenCreateModal();
            const resp = await periodsService.createPeriod(newPeriodId, newPeriodEventDate);
            if (resp) {
                http.apiResponse.showError("Periodo registrado correctamente", AlertTypes.SUCCESS);
            }
            getPeriods();
            setNewPeriodId(null);
            setNewPeriodEventDate(null);
        },
        handleOpenCreateModal: () => {
            setIsOpenCreateModal(!isOpenCreateModal);
        },
        handleInputKeyAction: (e: any) => {
            if (e.key === "Tab" && newPeriodSuggestion) {
                e.preventDefault();
                setNewPeriodId(newPeriodSuggestion);
            }
            if (e.key === "Enter" && e.target.value) {
                e.preventDefault();
                periodCreator.createPeriod();
            }
        }
    }

    const updatePeriod = async (id: string, isActive: boolean) => {
        let res = await periodsService.updatePeriod(id, isActive);
        if (res.status === HttpStatusCode.Ok) {
            getPeriods();
        }
    };

    useEffect(() => {
        getPeriods();
        updateAppTitle([{ title: 'Form' }, { title: 'Administración de periodos' }]);
    }, []);

    useEffect(() => {
        getNewPeriodSuggestion();
    }, [periods]);

    return (
        <div className='periods'>
            <div className="table-container">
                <div className="flex justify-between items-center w-[100%] my-3">
                    <div>
                        Cantidad total: {periods.length}
                    </div>
                    <Button
                        color="green"
                        onClick={periodCreator.handleOpenCreateModal}
                        placeholder=''
                    >
                        Abrir Nuevo Periodo
                    </Button>
                </div>
                <div className="table-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th
                                    className={'p-4'}
                                >
                                    <Typography
                                        variant="h6"
                                        className="font-normal leading-none"
                                        style={{ color: 'white', fontWeight: 'bold' }}
                                        placeholder=''
                                    >
                                        Periodo
                                    </Typography>
                                </th>
                                <th
                                    className={'p-4'}
                                >
                                    <Typography
                                        variant="h6"
                                        className="font-normal leading-none"
                                        style={{ color: 'white', fontWeight: 'bold' }}
                                        placeholder=''
                                    >
                                        Fecha de Evento
                                    </Typography>
                                </th>
                                <th
                                    className={'p-4'}
                                >
                                    <p
                                        className="font-normal"
                                        style={{ color: 'white', fontWeight: 'bold' }}
                                    >
                                        Acción
                                    </p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.map((period, index) => (
                                <tr key={index} className="even:bg-blue-gray-50/50">
                                    <td className="p-4 period-id">
                                        <Typography variant="paragraph" color="blue-gray" placeholder=''>
                                            {period.id}
                                        </Typography>
                                    </td>
                                    <td className="p-4 period-id">
                                        <Typography
                                            variant="paragraph"
                                            color="blue-gray"
                                            placeholder=""
                                        >
                                            {new Intl.DateTimeFormat("es-MX", {
                                                day: "numeric",
                                                month: "long",
                                                year: "numeric",
                                            }).format(new Date(period.eventDate))}
                                        </Typography>
                                    </td>
                                    <td className="text-end">
                                        <div className='flex justify-end items-center gap-4 pr-5'>
                                            <p style={{ color: 'lightslategray' }}>
                                                {period.isActive ? 'Periodo actual' : ''}
                                            </p>
                                            <Button
                                                color="blue"
                                                className={period.isActive ? "edit-button-disabled" : "edit-button"}
                                                placeholder=''
                                                onClick={() => period && updatePeriod(period.id, !period.isActive)}
                                            >
                                                {period.isActive ? "Desactivar" : "Activar"}
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='pagination'>
                {getPagination()}
            </div>
            <Dialog open={isOpenCreateModal} handler={periodCreator.handleOpenCreateModal} placeholder=''>
                <DialogHeader placeholder=''>Nuevo Periodo</DialogHeader>
                <DialogBody placeholder=''>
                    <div>
                        <Input
                            label='Nuevo Periodo'
                            value={newPeriodId}
                            onChange={(e) => {
                                setNewPeriodId(e.target.value)
                            }}
                            onKeyDown={periodCreator.handleInputKeyAction}
                            placeholder={newPeriodSuggestion ? ("Sugerencia: " + newPeriodSuggestion) : "AAAA-(1|2)"}
                            crossOrigin=''
                        />
                    </div>
                </DialogBody>
                <DialogBody placeholder=''>
                    <div>
                        <Input
                            type="date"
                            label="Nueva Fecha de Evento"
                            value={newPeriodEventDate}
                            onChange={(e) => {
                                setNewPeriodEventDate(e.target.value);
                            }}
                            crossOrigin=""
                        />
                    </div>
                </DialogBody>
                <DialogFooter placeholder=''>
                    <div className="flex items-center gap-2">
                        <label>Periodo Actual: {periods[0]?.id}</label>
                        <Button variant="text" color="red" onClick={periodCreator.handleOpenCreateModal} placeholder=''>
                            Cancelar
                        </Button>
                        <Button variant="gradient" color="green" onClick={periodCreator.createPeriod} placeholder=''>
                            Crear
                        </Button>
                    </div>
                </DialogFooter>
            </Dialog>
        </div>
    );
}
export default Periods;
